import { useQuery } from '@tanstack/react-query'
import { getPendingRows } from '@global/api'

export const KEY = 'pendingRows'

export const useDatasetPendingRows = ({ datasetId }) => {
  const isSelectivePath = Boolean(window.location.pathname.includes('selective'))

  return useQuery({
    queryKey: [KEY, datasetId],
    queryFn: ({ signal }) => getPendingRows({ datasetId, signal }),
    enabled: !isSelectivePath,
    refetchOnWindowFocus: false,
  })
}
